import React from "react"
import { Member, ImageWrapper, Image, Name, Title } from "./styles.js"

class TeamMember extends React.Component {
  render() {
    return (
      <Member>
        {this.props.picture && this.props.picture.url !== null ? (
          <ImageWrapper>
            <Image src={this.props.picture.url} alt={this.props.picture.alt} />
          </ImageWrapper>
        ) : null}
        <Name>{this.props.name}</Name>
        <Title>{this.props.bio}</Title>
      </Member>
    )
  }
}

export default TeamMember
